<template>
  <div>

    <p>
      I den här lektionen får du lära dig om ekokammare och filterbubblor. Vilken information får du ta del av på internet, och får dina vänner se samma saker som du?
    </p>

  </div>
</template>

<script>

//Exercises

export default {
  components: {
  },
  data () {
    return {
      'name': 'Ekokammare och filterbubblor',
      'route': 'ekokammare',
      'excercises': {
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/learn/lessons/data/EchoChambers.vue